/****   http.js   ****/
// 导入封装好的axios实例
import request from './request';
import store from '@/store/store';
import * as types from '../store/mutation-types';
import { Message } from 'element-ui';
import NProgress from 'nprogress';

// 回调
const httpCb = (flag, response, options) => {
  NProgress.done();

  if (flag) {
    if (options.success) {
      options.success(response);
      return;
    }
    if (options.onSuccess) {
      let obj = response.data?.obj ?? null;
      options.onSuccess({obj});
      return;
    }

    let json = response.data;

    if (json && json[types.KEY_STATUS]) {
      if (json[types.KEY_STATUS] >= 200) {
        if (json[types.KEY_STATUS] === types.CODE_SUCCESS) {
          let obj = json.obj || null;
          options.okcb && (options.okcb.call(this, obj, json.message));
          options.cb && (options.cb.call(this, json));
        } else {
          if (json[types.KEY_STATUS] === types.CODE_TIMEOUT) {
            Message.closeAll();
          }
          options.cb && (options.cb.call(this, json));
          options.errcb && (options.errcb.call(this, response.data));
          Message.error(json.message);
        }
      } else {
        options.cb && (options.cb.call(this, json));
      }
    } else {
      options.cb && (options.cb.call(this, json));
    }
  } else {
    if (options.fail) {
      options.fail(response);
      return;
    }
    if (options.onError) {
      options.onError(response);
      return;
    }

    options.cb && (options.cb.call(this, response.data));
    options.errcb && (options.errcb.call(this, response.data));
    response.data && Message.error(response.data);
  }
}

// get
const doGet = (options) => {
  const doRequest = (options) => {
    NProgress.start();

    let data = options.data || {};
    if (!options.headers) {
      options.headers = {};
    }
    let url = options.url;
    if (!(url.startsWith('//') || url.startsWith('http'))) {
      url = process.env.VUE_APP_API + url;
    }
    let _options = {headers: Object.assign({}, options.headers || {}), params: data, withCredentials:true};
    if (options.responseType) {
      _options.responseType = options.responseType;
    }
    // 加密标记
    _options.encry = (options.encry == undefined || options.encry == null || options.encry) ? true : false;

    request.get(url, _options)
      .then((response) => {
        httpCb(true, response, options);
      })
      .catch((response) => {
        httpCb(false, response, options);
      });
  }

  if (!store.getters.publickey) {
    store.dispatch('publickey', {
      callback: () => {
        doRequest(options);
      }
    });
  } else {
    doRequest(options);
  }
}

// post
const doPost = (options) => {
  const doRequest = (options) => {
    NProgress.start();
    
    let data = options.data || {};
    if (!options.headers) {
      options.headers = {};
    }
    let url = options.url;
    if (!(url.startsWith('//') || url.startsWith('http'))) {
      url = process.env.VUE_APP_API + url;
    }
    let _options = {headers: Object.assign({}, options.headers || {}, {'Content-Type': options.contentType || 'application/json'}), withCredentials:true};
    if (options.responseType) {
      _options.responseType = options.responseType;
    }
    if (options.timeout) {
      _options.timeout = options.timeout;
    }
    if (options.onUploadProgress) {
      _options.onUploadProgress = options.onUploadProgress;
    }
    // 加密标记
    _options.encry = (options.encry == undefined || options.encry == null || options.encry) ? true : false;
    // 加密数据标记
    _options.encry_data = options.formData ? false : true;

    const postData = options.formData ? options.formData : data;
    request.post(url, postData, _options)
      .then((response) => {
        httpCb(true, response, options);
      })
      .catch((response) => {
        httpCb(false, response, options);
      });
  }

  if (!store.getters.publickey) {
    store.dispatch('publickey', {
      callback: () => {
        doRequest(options);
      }
    });
  } else {
    doRequest(options);
  }
}

const doRequest = request;

//导出
export { doRequest, doGet, doPost };